/// <amd-module name="Wit/WorkItemForm/Attachments/Dialogs/ConfirmSkippingOversizedAttachmentsDialog" />
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { Dialog } from "VSSUI/Dialog";
import { formatFileSize } from "../AttachmentUtils";
import * as Resources from "Wit/WorkItemForm/Resources";

export interface IConfirmSkippingOversizedAttachmentsDialogProps {
    oversidedAttachmentNames: string[];
    maxFileSize: number;
    onUploadRemaining?: () => void;
    onCancelUpload: () => void;
}

export function ConfirmSkippingOversizedAttachmentsDialog({
    oversidedAttachmentNames,
    maxFileSize,
    onUploadRemaining,
    onCancelUpload
}: IConfirmSkippingOversizedAttachmentsDialogProps) {
    if (oversidedAttachmentNames.length === 0) {
        return null;
    }

    const footerButtonProps = onUploadRemaining
        ? [
              {
                  text: Resources.UploadRemainingFiles,
                  onClick: onUploadRemaining,
                  primary: true
              },
              { text: Resources.CancelUpload, onClick: onCancelUpload }
          ]
        : [{ text: Resources.CancelUpload, onClick: onCancelUpload, primary: true }];

    return (
        <Dialog
            className="confirm-skipping-oversized-attachments-dialog"
            titleProps={{ text: oversidedAttachmentNames.length > 1 ? Resources.AttachmentsOverSizeLimit : Resources.AttachmentOverSizeLimit }}
            onDismiss={onCancelUpload}
            footerButtonProps={footerButtonProps}
        >
            {oversidedAttachmentNames.length > 1 ? (
                <>
                    <div>{format(Resources.FilesOverSizeLimit, formatFileSize(maxFileSize))}</div>
                    <ul className="oversized-attachments-list">
                        {oversidedAttachmentNames.map((fileName, i) => (
                            <li key={i}>{fileName}</li>
                        ))}
                    </ul>
                </>
            ) : (
                <div>{format(Resources.FileOverSizeLimit, oversidedAttachmentNames[0], formatFileSize(maxFileSize))}</div>
            )}
        </Dialog>
    );
}
